import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
} from '@angular/router';
import { Location} from '@angular/common';
import { Artikel } from '../models/artikel.model';
import { Lagerplatz } from '../models/lagerplatz.model';

import { ArtikelService } from '../services/artikel.service';
import { LagerplatzService } from '../services/lagerplatz.service';

@Component({
  selector: 'sws-artikeldetails',
  templateUrl: './artikeldetails.component.html',
  styleUrls: ['./artikeldetails.component.css']
})
export class ArtikeldetailsComponent implements OnInit {

    artnr: string ;
    artDetail: Artikel ;
    lagerPlaetze: Lagerplatz[] = [];

  constructor(private artSuche: ArtikelService,
              private lpSuche: LagerplatzService,
              private route: ActivatedRoute,
              private location: Location) {

    this.artDetail = new Artikel() ;
    this.artDetail.ATBezeichnung1 = "wird geladen...";
  }

  ngOnInit() {
    // Auslesen der Artikelnummer aus der Route
    const params = this.route.snapshot.params;
    this.artnr = params['artnr'];
    // Lesene eines einzelnen Artikels. Laden in this.artDetail
    this.artSuche.getArtikelSingle( this.artnr )
      .subscribe(art => {
        this.artDetail = art;
        console.log("geladen:" + this.artDetail);
      });
    // Lesen der Lagerplätze eines einzelnen Artikels. Laden in this.lagerPlaetze
    this.lpSuche.getLagerplatzliste( this.artnr, "100" )
      .subscribe(lplaetze => {
        this.lagerPlaetze = lplaetze;
        console.log(this.lagerPlaetze.length + " Plätze geladen" );
      });
  }

  goBack(): void {
    this.location.back();
  }

  print(): void {
       let printContents, popupWin;
       printContents = document.getElementById('printSection').innerHTML;
       popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
       popupWin.document.open();
       popupWin.document.write(`
          <html>
              <head>
                  <title>Druck Lagerbestand Seidler</title>
                  <style>
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
       );
       popupWin.document.close();   


  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/artikeldetails/artikeldetails.component.ts